import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { gsap } from "gsap";
import { Box, Container, Typography, IconButton, Stack, Link, Avatar, CardMedia, Grid, styled } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { dprlogo } from '../../../assets';





const slugify = (text: string) =>
  text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');

const BlogDetails: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [blog, setBlog] = useState<any>(null);
  const titleRef = useRef<HTMLDivElement | null>(null);
  const imageRef = useRef<HTMLDivElement | null>(null);

  const profile = {
    name: 'Deccan Progressive Realty LLP.',
    title: '',
    description:
      'Real Estate Experts | Investment Advisors | Wealth Builder | Trusted by Clients Nationwide | Maximizing ROI',
    avatarUrl:'https://dprstorage.b-cdn.net/dprstorage/dprlinkedinlogo.jpeg',
    linkedInUrl: 'https://www.linkedin.com/company/deccan-progressive-realty-llp/',

  };

  useEffect(() => {
    if (!titleRef.current) return;

    const title = titleRef.current;

    // Clear existing content
    title.innerHTML = "";

    // Split title into words (preserving spacing)
    const titleWords = title.dataset.text?.split(" ") || [];
    titleWords.forEach((word) => {
      const span = document.createElement("span");
      span.style.display = "inline-block";
      span.style.opacity = "0";
      span.textContent = word + " "; // Add space after each word
      title.appendChild(span);
    });
    // GSAP animations - Right to Left (x: -70 for title)
    gsap.to(title.querySelectorAll("span"), {
      duration: 2,
      x: -20, // Animate from right to left
      autoAlpha: 1,
      stagger: 0.09, // Animate each word separately
    });
  }, []);

  useEffect(() => {
    if (imageRef.current) {
      gsap.to(imageRef.current, {
        scale: 1.5, // Zoom effect
        duration: 0.5,
        ease: "power1.out",
        scrollTrigger: {
          trigger: imageRef.current,
          scrub: 1, // Smooth reverse effect
          start: "top bottom",
          end: "bottom top",
        },
      });
    }
  }, []);



  useEffect(() => {
    axios
      .get('https://blog.dprprop.com/clients/6819a43f5485188c126d1d35/blogs')
      .then((res) => {
        const found = res.data.blogs.find(
          (b: any) => slugify(b.title) === slug
        );
        setBlog(found);
      });
  }, [slug]);

  if (!blog) return <p>Loading blog...</p>;

  const appUrl = `${window.location.origin}/blogs/${slug}`;

  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(appUrl)}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(appUrl)}&text=${encodeURIComponent(blog.title)}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(appUrl)}&title=${encodeURIComponent(blog.title)}`,
  };


  return (
    <Box sx={{ background: 'white' }}>
      <Box sx={{ mt: 6 }} >

        <Container>
          <Grid container spacing={2} alignItems="flex-start"
          >
            <Grid item xs={12} lg={12}>

              <Box mt={7} textAlign="start">
                <Typography
                  variant="h4"
                  component="div"
                  sx={{ fontWeight: "600", color: "primary.main" }}
                >
                  {blog.title}
                </Typography>
              </Box>

            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="xl" sx={{ pb: 8 }}>

        <Box sx={{ mb: 5, px: { xs: 0, md: 8 }, }}>
          {/* <Box
            sx={{
              position: "relative",
              height: "auto",
              width: "100%",
              overflow: "hidden",
            }}
          >
            <GrowImage
              ref={imageRef}
              className="grow"
              style={{
                backgroundImage: `url(${blog.bannerImage})`,
                backgroundPosition: "center 0%", // Set the top position to 40%
              }}
            />
          </Box> */}

          <CardMedia
            component="img"
            height="auto"
            src={`https://dprstorage.b-cdn.net${blog.imageurl}`}
            alt="Blog"
            sx={{ transition: "transform 0.3s ease-in-out", mt: 4 }}

          />


          {blog.sections.map((section: any) => {
            const Tag = section.type as keyof HTMLElementTagNameMap;
            return (
              <Box key={section._id} sx={{ marginBottom: '20px', textAlign: 'start' }}>
                {React.createElement(
                  Tag,
                  { style: { marginBottom: '5px', color: '#000' } },
                  section.title
                )}
                <Typography variant='body2' sx={{ color: 'black' }}>{section.description}</Typography>
              </Box>
            );
          })}

          {/* {blog.embedposturl && blog.embedposturl.includes('linkedin.com') && ( */}
          {/* <Box sx={{ mt: 5 }}>
              <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:share:7293999163199918080"
                height="450"
                width="100%"
                frameBorder="0"
                allowFullScreen
                title="LinkedIn Post"
                style={{ borderRadius: '8px' }}
              />
            </Box> */}
          {/* )} */}

          {/* Social Share Icons */}
          <Box sx={{ mt: 6 }}>
            <Typography variant="h4" sx={{ mb: 3, textAlign: 'start', color: 'black' ,fontWeight:700}}>
              Share this story:
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton
                component="a"
                href={shareLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                sx={{
                  backgroundColor: '#000',
                  borderRadius: '10px',
                  color:'white',
                  p: 1,
                  '&:hover': {
                    backgroundColor: '#fff',
                    color:'black'
                  },
                }}
              >
                <FacebookIcon  sx={{ fontSize: '30px', }} />
              </IconButton>

              <IconButton
                component="a"
                href={shareLinks.twitter}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                sx={{
                  backgroundColor: '#000',
                  borderRadius: '10px',
                  color:'white',
                  p: 1,
                  '&:hover': {
                    backgroundColor: '#fff',
                    color:'black'
                  },
                }}
              >
                <TwitterIcon  sx={{ fontSize: '30px', }} />
              </IconButton>

              <IconButton
                component="a"
                href={shareLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                sx={{
                  backgroundColor: '#000',
                  borderRadius: '10px',
                  color:'white',
                  p: 1,
                  '&:hover': {
                    backgroundColor: '#fff',
                    color:'black'
                  },
                }}
              >
                <LinkedInIcon  sx={{ fontSize: '30px', }} />
              </IconButton>
            </Stack>
          </Box>
          <Link
            href={profile.linkedInUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: "none",

            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              p={2}
              sx={{
                border: '1px solid #ddd',
                borderRadius: 2,
                maxWidth: 1200,
                backgroundColor: '#fff',
                boxShadow: 1,
                mt: 5
              }}
            >
              <Box display="flex" alignItems="start" gap={2}
                sx={{
                  flexDirection: { xs: 'column', sm: 'row' }, // ✅ Stack content vertically on mobile
                  width: '100%',
                }}
              >
                <Avatar src={profile.avatarUrl} alt={profile.name} sx={{ width: 100, height: 100 }} />
                <Box>
                  <Typography fontWeight="bold" sx={{ textAlign: 'start', color: 'black' }}>
                    {profile.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'start', mt: 1 }}>
                    {profile.description}
                  </Typography>
                </Box>
                {/* ✅ Replace LinkedInIcon with image */}
                <Box
                  component="img"
                  src="https://dprstorage.b-cdn.net/RW/LinkedIn-Logo.wine.png"
                  alt="LinkedIn"
                  sx={{ width: 160, height: 100 }}
                />
              </Box>
            </Box>

          </Link>

        </Box>
      </Container>
    </Box>
  );
};

export default BlogDetails;
